import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { PackageIcon } from '@phosphor-icons/react'

import { ScrollableTabs } from '@reveni-io/reveni-ui'

import TitlePage from '@/common/components/TitlePage/TitlePage'
import AppContext from '@/common/context/app.context'

import useParcelTab from './hooks/useParcelTab/useParcelTab'
import * as Styles from './styles'

const ParcelsPage = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const allowsOutbound = info?.selectedStore?.preferences?.allows_outbound
  const allowsShipments = info?.selectedStore?.preferences?.allows_shipments
  const { parcelTab, visibleTabs, handleTabChange } = useParcelTab({ allowsOutbound, allowsShipments })

  const translatedTabs = visibleTabs.map(tab => ({ ...tab, label: t(tab.label) }))

  return (
    <Styles.MainContainer>
      <TitlePage Icon={PackageIcon}>
        {t('Envíos')} - {info?.selectedStore?.name}
      </TitlePage>
      <Styles.TabsContainer>
        <ScrollableTabs tabs={translatedTabs} value={parcelTab} onChange={handleTabChange} />
      </Styles.TabsContainer>
      <Outlet />
    </Styles.MainContainer>
  )
}

export default ParcelsPage
